import React from "react";

import DocSVG from "modules/theme/icons/general/doc.svg";
import VideoSVG from "modules/theme/icons/general/video.svg";

import * as styles from "./styles.module.scss";

type CategoryNameProps = {
  title: string | undefined;
};

const CategoryName = ({ title }: CategoryNameProps) => {
  let text;
  let type;
  let icon;
  switch (title) {
    case "tutorial":
    case "webinar":
      icon = "video";
      text = "Watch this ";
      type = title;
      break;
    case "podcast":
      icon = "video";
      text = "Listen to this ";
      type = title;
      break;
    default:
      icon = "doc";
      text = "Read this ";
      type = title;
  }
  return (
    <span className={styles.cta}>
      {icon === "doc" && <DocSVG />}
      {icon === "video" && <VideoSVG />}
      {text} <span>{type?.replace(/\-/g, " ")}</span>
    </span>
  );
};

export default CategoryName;
